import React from "react";

export default function UseCase() {
  return (
    <div className="bg-midBlue">
      <div className="mainDiv w-6/12 flex-col mx-auto justify-center text-white py-20 text-center">
        <h1 className="text-4xl font-bold">
          <span className="text-orange">Use</span> cases
        </h1>
        <div className="bottom flex flex-col lg:flex-row mx-auto justify-between gap-x-20 text-left pt-16 font-light">
          <ul className="list-disc">
            <li className="pb-6">Educational translation and localization</li>
            <li className="pb-6">E-learning documentation translation and localization</li>
            <li className="pb-6">E-commerce localization</li>
            <li className="pb-6">Software app localization for smartphones</li>
          </ul>
          <ul className="list-disc">
            <li className="pb-6">iPad and iPhone app localization</li> 
            <li className="pb-6">Graphic user interface or GUI localization</li>
            <li className="pb-6">Subtitling localization</li>
            <li className="pb-6">Broadcast commercial translation and localization</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
